import { router } from '../app.js'; // Añadir .js
import { authService } from '../services/authService.js'; // Añadir .js

export function Header() {
    const headerElement = document.createElement('header');
    headerElement.className = 'header';

    const title = document.createElement('h1');
    title.textContent = 'Sistema de Taquilla Hípica';

    const nav = document.createElement('nav');
    const ul = document.createElement('ul');

    const links = [
        { name: 'Taquilla', path: '/cashier', roles: ['cashier', 'admin'] },
        { name: 'Administración', path: '/admin', roles: ['admin'] },
        { name: 'Pago de Premios', path: '/payout', roles: ['payout_agent','cashier', 'admin'] },
    ];

    links.forEach(link => {
        const user = authService.getCurrentUser();
        if (user && link.roles.includes(user.role)) {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#'; // Previene la navegación por defecto
            a.textContent = link.name;
            a.addEventListener('click', (e) => {
                e.preventDefault();
                router.navigate(link.path);
            });
            li.appendChild(a);
            ul.appendChild(li);
        }
    });

    const logoutLi = document.createElement('li');
    const logoutBtn = document.createElement('a');
    logoutBtn.href = '#';
    logoutBtn.textContent = 'Cerrar Sesión';
    logoutBtn.addEventListener('click', (e) => {
        e.preventDefault();
        authService.logout();
        router.navigate('/login');
    });
    logoutLi.appendChild(logoutBtn);
    ul.appendChild(logoutLi);

    nav.appendChild(ul);

    headerElement.appendChild(title);
    headerElement.appendChild(nav);

    return headerElement;
}
